import * as React from "react";
const ArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={19} height={8} fill="none" {...props}>
    <path stroke="#fff" strokeLinecap="round" strokeWidth={1.5} d="M1.637 4.03H17.01m0 0-2.785-2.897m2.785 2.896-2.785 2.786" />
  </svg>
);
export default ArrowRight;
